var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighballIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.465 68.6466V93.912L112.922 143.781C112.53 146.767 109.985 149 106.973 149H54.2178C51.1934 149 48.6418 146.749 48.2646 143.748L42 93.912V55.3232C42 52.0095 44.6863 49.3232 48 49.3232H100.142",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.464 68.6467C130.136 68.6467 138.787 59.9953 138.787 49.3234C138.787 38.6514 130.136 30 119.464 30C108.792 30 100.141 38.6514 100.141 49.3234C100.141 59.9953 108.792 68.6467 119.464 68.6467Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.465 93.9062C119.465 93.9062 106.057 99.1559 80.7324 99.1559C55.4076 99.1559 42 93.9062 42 93.9062",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.493 58.6877C124.592 58.6877 128.726 54.5539 128.726 49.4547C128.726 44.3554 124.592 40.2217 119.493 40.2217C114.394 40.2217 110.26 44.3554 110.26 49.4547C110.26 54.5539 114.394 58.6877 119.493 58.6877Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighballIcon);
export default __webpack_public_path__ + "static/media/highball-icon.026e08a46ee572209b2680be3e977476.svg";
export { ForwardRef as ReactComponent };